import React from 'react'

const SalesAnalytics = () => {
  return (
    <div>SalesAnalytics</div>
  )
}

export default SalesAnalytics